export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14710.3fe8a5f7.jpg";